import React, { Fragment, useState, useEffect } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import ProfileCard from "./ProfileCard";
import ChangePasswordCard from "./ChangePasswordCard";
import PartnerTokenCard from "./PartnerTokenCard";

const AccountPage = () => {
  const [userData, setUserData] = useState(null);
  const [partnerUuid, setPartnerUuid] = useState("");

  useEffect(() => {
    const storedUserData = localStorage.getItem("user_data");
    if (storedUserData) {
      try {
        const parsed = JSON.parse(storedUserData);
        setUserData(parsed);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }

    const pUuid = localStorage.getItem("partner_uuid");
    if (pUuid) {
      setPartnerUuid(pUuid);
    }
  }, []);

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Account" />
      <Container fluid={true}>
        <Row>
          <ProfileCard userData={userData} />
          <ChangePasswordCard />
          <PartnerTokenCard partnerUuid={partnerUuid} />
        </Row>
      </Container>
    </Fragment>
  );
};

export default AccountPage;
